import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { AsideComponent, AsideLink } from '../aside/aside.component';

/** Main component. */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-main',
  imports: [RouterModule, AsideComponent],
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css'],
})
export class MainComponent {
  /** Links. */
  @Input()
  public links: readonly AsideLink[] = [];

  private readonly router = inject(Router);

  /** Page title. */
  protected get title(): string {
    const activeLink = this.links.find(link => this.router.url.split('?')[0] === link.path);
    return activeLink ? activeLink.title : '';
  }
}
